import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsx } from 'react/jsx-runtime';

var BookmarkIcon = ZepIcon_default((props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4a3 3 0 0 0-3 3v12.131l4.445-2.963a1 1 0 0 1 1.11 0L17 19.13V7a3 3 0 0 0-3-3h-4Zm-3.536-.536A5 5 0 0 1 10 2h4a5 5 0 0 1 5 5v14a1 1 0 0 1-1.555.832L12 18.202l-5.445 3.63A1 1 0 0 1 5 21V7a5 5 0 0 1 1.464-3.536Z",
    fill: props.fill || "currentColor"
  }
) }));

export { BookmarkIcon };
